import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import { updateEvaluation } from '../../services/evaluationService';
import { useParams } from 'react-router-dom';

const LimitBanner = ({ className, limits, evaluationData }) => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [emailSuccess, setEmailSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams();

  const totalSegments = evaluationData?.statistics?.totalSegments || 0;
  //const completedSegments = evaluationData?.statistics?.completed || 0;
  const exceedsLimit = totalSegments > (limits?.maxSegments || 0);
  //const unprocessedSegments = totalSegments - completedSegments;

  const handleEmailSubmit = async () => {
    setEmailError('');
    setIsSubmitting(true);

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      setEmailError('Please enter a valid email address.');
      setIsSubmitting(false);
      return;
    }

    try {
      await updateEvaluation(id, 'email', email);
      setEmailSuccess(true);
      
      setTimeout(() => {
        setEmailSuccess(false);
        setEmail('');
      }, 3000);
    } catch (err) {
      setEmailError('Failed to save email. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // If file exceeds limit, show special block
  if (exceedsLimit) {
    return (
      <div className="bg-[#CAF1D9] rounded-2xl p-4 mb-8">
        <div>
          <h3 className="text-2xl font-bold text-[#020817] mb-2">
            Finish Evaluation
          </h3>
          <div className="text-[#6B7280] mb-6 space-y-2">
            <p>
              You wanted to evaluate the translation of <strong>{totalSegments.toLocaleString()} segments</strong>. Our free evaluation offers up to <strong>{limits?.maxSegments} segments</strong> and <strong>{limits?.maxChars?.toLocaleString()} characters</strong>.
              <br></br>To evaluate the entire text, please leave us email and we will send you the full evaluation report (pdf and csv).
            </p>
          </div>
          
          <div className="flex justify-between items-end mx-auto">
            <div className="flex gap-3">
            <input
              type="email"
              className="flex-1 h-10 w-[360px] max-w-[360px] border border-gray-300 rounded px-3 py-2 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={emailSuccess || isSubmitting}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !emailSuccess && !isSubmitting) {
                  handleEmailSubmit();
                }
              }}
            />
            <button
              className="px-6 py-2 bg-[#22C55E] text-white shadow-[0px_1px_2px_0px_#0000000D]
              rounded hover:bg-[#139041] focus:outline-none focus:ring-2 focus:ring-[#139041] 
              disabled:opacity-50 disabled:cursor-not-allowed font-medium"
              onClick={handleEmailSubmit}
              disabled={emailSuccess || isSubmitting}
            >
              {isSubmitting ? 'Sending...' : emailSuccess ? 'Sent!' : 'Get Evaluation'}
            </button>
            </div>
            <div className="text-xs text-[#6B7280] leading-5">
              Service provided by Alconost Inc., USA
            </div>
          </div>
          
          {emailError && (
            <div className="text-red-600 text-sm mb-2">{emailError}</div>
          )}
          
          {emailSuccess && (
            <div className="text-green-600 text-sm mb-2">
              ✅ Email saved! You'll receive the full evaluation report soon.
            </div>
          )}
        </div>
      </div>
    );
  }

  // Standard block for files within limit
  return (
    <div className={className ? className : "bg-yellow-200 border border-yellow-100 rounded-lg p-4 mb-6"}>
      <div className={className ? "flex items-center space-x-3" : "flex items-start space-x-3"}>
        <div className="flex-shrink-0">
          {className ? 
            <ExclamationTriangleIcon className="h-5 w-5 text-[#2563EB] flex-shrink-0" /> 
            :
            <ExclamationTriangleIcon className="h-5 w-5 text-yellow-500" />
          }
        </div>
        <div className="flex-1">
          <p className="text-sm text-gray-600">
            Our free evaluation offers up to {limits?.maxSegments} segments or {limits?.maxChars} characters. <br></br>Looking for more? Just email us at <a href="mailto:mt-evaluate@alconost.com" className="text-blue-500 hover:underline whitespace-nowrap">mt-evaluate@alconost.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LimitBanner; 